export const customFontStyles = `
  @font-face {
    font-family: 'CooperBT';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://sfo3-space-ah-assets.sfo3.digitaloceanspaces.com/assets/fonts/CooperBT-Medium.ttf') format('truetype');
  }

  @font-face {
    font-family: 'CooperBT';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://sfo3-space-ah-assets.sfo3.digitaloceanspaces.com/assets/fonts/CooperBT-Medium.ttf') format('truetype');
  }

  @font-face {
    font-family: 'CooperBT';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('https://sfo3-space-ah-assets.sfo3.digitaloceanspaces.com/assets/fonts/CooperBT-MediumItalic.ttf') format('truetype');
  }

  @font-face {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://sfo3-space-ah-assets.sfo3.digitaloceanspaces.com/assets/fonts/DMSans-Medium.ttf') format('truetype');
  }

  @font-face {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://sfo3-space-ah-assets.sfo3.digitaloceanspaces.com/assets/fonts/DMSans-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'DM Sans';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('https://sfo3-space-ah-assets.sfo3.digitaloceanspaces.com/assets/fonts/DMSans-MediumItalic.ttf') format('truetype');
  }

  @font-face {
    font-family: 'DM Serif Display';
    font-weight: 400;
    font-display: swap;
    src: url('https://sfo3-space-ah-assets.sfo3.cdn.digitaloceanspaces.com/assets/fonts/DMSerifDisplay-Regular.ttf') format('truetype');
  }
`;

export const FONT_HEADING = 'CooperBT, system-ui, -apple-system, sans-serif';
export const FONT_TEXT = "'DM Sans', system-ui, -apple-system, sans-serif";
export const FONT_CALENDAR_HEADING =
  'DM Serif Display, system-ui, -apple-system, sans-serif';
